import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import isEmpty from "../../validation/is-empty";
import { getConfig } from "../../actions/gameActions";

class Navbar extends Component {
  componentDidMount() {
    this.props.getConfig();
    document.title = "龍邑遊戲|官網";
  }
  render() {
    const { games, config } = this.props;
    //console.log("games", games);
    //console.log("config", config);

    let gamesMenu;
    if (games.length === 0) {
      gamesMenu = null;
    } else {
      gamesMenu = games
        .filter((game) => !isEmpty(game.site))
        .map((game) => (
          <a key={game.game_id} className="dropdown-item" href={game.site}>
            {game.game_name}
          </a>
        ));

      //console.log("gamesMenu", gamesMenu);
    }
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <a href={config.main_site} className="navbar-brand">
            <div className="nav_logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#mobile-nav"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="mobile-nav">
            <ul
              className="navbar-nav ml-auto"
              style={{ fontFamily: "Microsoft JhengHei" }}
            >
              <li className="nav-item">
                <a href={config.main_site} className="nav-link">
                  首頁
                </a>
              </li>
              <li className="nav-item">
                <a href={`${config.support_site}support`} className="nav-link">
                  客服
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  href="!#"
                >
                  遊戲
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {gamesMenu}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  getConfig: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  games: state.games.games,
  config: state.games.config,
});

export default connect(mapStateToProps, { getConfig })(Navbar);
//export default Navbar;
